import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-477a3bde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-nested-menu" }
const _hoisted_2 = { class: "my-nested-menu" }
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "mx-2 my-1" }

import AppRadio from "@/components/Form/AppRadio.vue";
import Dropdown from "@/components/ui/Dropdown/Dropdown.vue";
import NavItem from "@/components/Navigation/NavItem.vue";
import {PropType} from "~~/vue";
import {ILocationPackage} from "@/api/services/packages/esim/location-packages/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectPackage',
  props: {
  plans: {
    type: Object as PropType<ILocationPackage[]>,
    required: true
  }
},
  emits: {
  changePackage: null
},
  setup(__props, { emit }) {







return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.plans, (el, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: '' + index
    }, [
      _createVNode(Dropdown, { "parent-opened": true }, {
        "dropdown-title": _withCtx(() => [
          _createVNode(NavItem, {
            "is-top-level": true,
            name: el.name
          }, null, 8, ["name"])
        ]),
        "dropdown-content": _withCtx(() => [
          _createElementVNode("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(el.regionPlans, (region, index2) => {
              return (_openBlock(), _createBlock(Dropdown, {
                "parent-opened": true,
                key: '' + index + index2 * 100
              }, {
                "dropdown-title": _withCtx(() => [
                  _createVNode(NavItem, {
                    "is-top-level": false,
                    name: region.plan.name
                  }, null, 8, ["name"])
                ]),
                "dropdown-content": _withCtx(() => [
                  _createElementVNode("ul", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.plan.packages, ({title, id}, index3) => {
                      return (_openBlock(), _createElementBlock("label", {
                        for: 'plan' + id,
                        class: "d-flex align-items-center pointer",
                        key: '' + index + index2 * 100 + index3 * 10000
                      }, [
                        _createVNode(AppRadio, {
                          id: 'plan' + id,
                          name: "type",
                          onChange: ($event: any) => (emit('changePackage', id))
                        }, null, 8, ["id", "onChange"]),
                        _createElementVNode("strong", _hoisted_4, _toDisplayString(title), 1)
                      ], 8, _hoisted_3))
                    }), 128))
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]),
        _: 2
      }, 1024)
    ]))
  }), 128))
}
}

})